'use client'

import React, { useEffect, useState } from 'react'
import { textStyles, ShareButtons } from '@marketing-sites/ui'
import type { ShareArticleButtonsFragment } from '../../../.graphql/generated-types'

export interface ShareArticleButtonsProps {
  data: ShareArticleButtonsFragment
}

export function ShareArticleButtons({ data }: ShareArticleButtonsProps) {
  const [url, setURL] = useState<string | null>(null)

  useEffect(() => {
    const urlInstance = new URL(window.location.href)
    const slug = data.slug ?? ''
    urlInstance.pathname = `/articles/${slug}`
    setURL(urlInstance.toString())
  }, [data.slug])

  const isVisible = !!url
  if (isVisible) {
    return (
      <div>
        <h2 className={`${textStyles.h2} text-center md:text-left`}>
          Don&apos;t forget to share this article!
        </h2>
        <ShareButtons url={url} emailSubject={data.name ?? ''} />
      </div>
    )
  }
  return null
}
